import React, { FC, useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import useThunkDispatch from '../../common/useThunkDispatch'
import Splash from '../../components/Splash'
import withAccountAndBranch from '../../common/withAccountAndBranch'
import { IAccount, IBranch } from '../../types/user'
import { IInboundInventory } from '../../types/common'
import { requestInboundInventory } from '../managerActions'
import ShipmentDetails from './shipmentDetials'
import TransferDetails from './transferDetails'
import BugIcon from '../../icons/bug.svg'

interface IOrderRouteParams {
  account: IAccount
  branch?: IBranch
}

const InboundInventory: FC<IOrderRouteParams> = ({ account, branch }) => {
  const dispatch = useThunkDispatch()
  const {
    inboundInventoryId,
    accountId: accountIdParam,
    branchId,
  } = useParams()
  const navigate = useNavigate()
  const { orderNumber, fromHistory } = (useLocation().state ?? {}) as {
    orderNumber?: string
    fromHistory?: boolean
  }
  const id = Number(inboundInventoryId)
  const accountId = accountIdParam ? Number(accountIdParam) : undefined
  // undefined while loading, null when the user can't see it
  const [inboundInventory, setInboundInventory] = useState<
    IInboundInventory | null | undefined
  >(undefined)

  // load
  useEffect(() => {
    const perform = async () => {
      const inboundInventory = await dispatch(
        requestInboundInventory(id, accountId),
      )
      setInboundInventory(inboundInventory)
    }

    perform()
  }, [id])

  // on back
  const handleBack = useCallback(() => {
    if (fromHistory) return navigate(-1)

    const link = accountIdParam
      ? `/clients/${accountIdParam}/branches/${branchId}/inbound_inventories`
      : '/inbound_inventories'
    navigate(link)
  }, [account, branch, fromHistory])

  if (inboundInventory === undefined) return <Splash isLoading />

  if (inboundInventory === null) {
    return (
      <div className="replenishment-empty">
        <div className="replenishment-empty_title">Not found</div>
        <div className="replenishment-empty_message">
          {orderNumber
            ? `Not found order with number ${orderNumber}`
            : 'This inbound inventory does not exist or is not available'}
        </div>
        <BugIcon className="replenishment-empty_icon" />
      </div>
    )
  }

  return (
    <>
      {inboundInventory.recordType === 'invoice' ? (
        <ShipmentDetails
          onClose={handleBack}
          inboundInventory={inboundInventory}
          onSave={(val) => setInboundInventory(val)}
          accountId={accountId}
        />
      ) : (
        <TransferDetails
          onClose={handleBack}
          inboundInventory={inboundInventory}
          onSave={(val: IInboundInventory) => setInboundInventory(val)}
          accountId={accountId}
        />
      )}
    </>
  )
}

export default withAccountAndBranch(InboundInventory)
